<template>
  <div class="wrapper">
    <header class="header">
      <div class="back" @click="$router.back()">
        <img src="~images/back.png" width="10" />
        <span>返回</span>
      </div>
      <el-button class="export-btn" size="small" type="primary" @click="exportData">导出</el-button>
    </header>
    <div class="info">
      <el-select class="grade-select-list" size="small" value-key="gradeNum" v-model="startYearData">
        <el-option v-for="(item, i) in studentGradeList" :key="'grade-' + i" :label="item.gradeName" :value="item">
        </el-option>
      </el-select>
      <div class="info-top">
        <div class="avatar">{{ studentDetail.studName ? studentDetail.studName.split('')[0] : '' }}</div>
        <div class="name">{{ studentDetail.studName }}</div>
      </div>
      <div class="info-bottom">
        <span>学校：{{ studentDetail.schoolName }}</span>
        <span>年级：{{ startYearData.gradeName }}</span>
        <span>班级：{{ startYearData.className }}</span>
      </div>
    </div>
    <div class="section section1">
      <div class="title">学年总结</div>
      <div class="container" style="margin:0 -5px;">
        <div class="total-item" style="flex:4">
          <div class="left">
            <img src="~images/grade_1.png" alt />
          </div>
          <div class="right">
            <div class="item-title">{{ studentOverviewData.examNum }}</div>
            <div class="desc">共参加考试（场）</div>
          </div>
        </div>
        <div class="total-item" style="flex:4">
          <div class="left">
            <img src="~images/grade_7.png" alt />
          </div>
          <div class="right">
            <div class="item-title">{{ studentOverviewData.schoolExamNum }}/{{ studentOverviewData.regionExamNum }}
            </div>
            <div class="desc">学校/区域考试（场）</div>
          </div>
        </div>
        <div class="total-item" style="flex:3">
          <div class="left">
            <img src="~images/grade_5.png" alt />
          </div>
          <div class="right">
            <div class="item-title">{{ studentOverviewData.wonderNum }}</div>
            <div class="desc">优秀（场）</div>
          </div>
        </div>
        <div class="total-item" style="flex:3">
          <div class="left">
            <img src="~images/grade_4.png" alt />
          </div>
          <div class="right">
            <div class="item-title">{{ studentOverviewData.goodNum }}</div>
            <div class="desc">良好（场）</div>
          </div>
        </div>
        <div class="total-item" style="flex:3">
          <div class="left">
            <img src="~images/grade_3.png" alt />
          </div>
          <div class="right">
            <div class="item-title">{{ studentOverviewData.passNum }}</div>
            <div class="desc">及格（场）</div>
          </div>
        </div>
        <div class="total-item" style="flex:3">
          <div class="left">
            <img src="~images/grade_2.png" alt />
          </div>
          <div class="right">
            <div class="item-title">{{ studentOverviewData.tiredNum }}</div>
            <div class="desc">学困（场）</div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="left" style="position:relative">
          <div v-show="ifRadarChartShow" id="radar"></div>
          <div v-show="!ifRadarChartShow" style="text-align: center;height: 150px;padding-top: 150px;color:#999;background-color:#fff">
            <img src="~images/nodata.png" alt width="100" />
            <p style="margin-bottom: 20px">暂无数据</p>
          </div>
        </div>
        <div class="right">
          <div class="top">
            <div v-if="bestAndWorstExamData && bestAndWorstExamData.bestExam">
              <div class="label">最好成绩</div>
              <div class="title">{{ bestAndWorstExamData.bestExam.examName }}</div>
              <div class="content">
                <div class="item">
                  <div>
                    <div class="text" style="color:#5192F9">
                      <span>班级平均分</span>
                      <span>{{ parseFloat(bestAndWorstExamData.bestExam.classAverageScore).toFixed(2) }}分</span>
                    </div>
                    <el-progress v-if="parseFloat(bestAndWorstExamData.bestExam.totalScore) > 0" :format="format" color="#5192F9" :stroke-width="10" :show-text="false" :percentage="parseFloat(bestAndWorstExamData.bestExam.classAverageScore / bestAndWorstExamData.bestExam.totalScore * 100)"></el-progress>
                  </div>
                  <div>
                    <div class="text" style="color:#48BFFE">
                      <span>击败本班级同学</span>
                      <span>{{ parseFloat(bestAndWorstExamData.bestExam.classBitRatio * 100).toFixed(2) }}%</span>
                    </div>
                    <el-progress :format="format" :stroke-width="10" :show-text="false" color="#48BFFE" :percentage="parseFloat(bestAndWorstExamData.bestExam.classBitRatio * 100)"></el-progress>
                  </div>
                </div>
                <div class="item">
                  <div id="bestPieChart"></div>
                </div>
                <div class="item">
                  <div>
                    <div class="text" style="color:rgba(255, 190, 65, 1)">
                      <span>年级平均分</span>
                      <span>{{ parseFloat(bestAndWorstExamData.bestExam.gradeAverageScore).toFixed(2) }}分</span>
                    </div>
                    <el-progress v-if="parseFloat(bestAndWorstExamData.bestExam.totalScore) > 0" :format="format" :stroke-width="10" :show-text="false" color="rgba(255, 213, 132, 1)" :percentage="parseFloat(bestAndWorstExamData.bestExam.gradeAverageScore / bestAndWorstExamData.bestExam.totalScore * 100)"></el-progress>
                  </div>
                  <div>
                    <div class="text" style="color:rgba(254, 174, 104, 1)">
                      <span>击败本年级同学</span>
                      <span>{{ parseFloat(bestAndWorstExamData.bestExam.gradeBitRatio * 100).toFixed(2) }}%</span>
                    </div>
                    <el-progress :format="format" :stroke-width="10" :show-text="false" color="rgba(254, 174, 104, 1)" :percentage="parseFloat(bestAndWorstExamData.bestExam.gradeBitRatio * 100)"></el-progress>
                  </div>
                </div>
              </div>
            </div>
            <div v-else style="text-align: center;height: 150px;padding-top: 70px;color:#999;background-color:#fff">
              <img src="~images/nodata.png" alt width="100" />
              <p style="margin-bottom: 20px">暂无数据</p>
            </div>
          </div>
          <div class="bottom">
            <div v-if="bestAndWorstExamData && bestAndWorstExamData.worstExam">
              <div class="label">最差成绩</div>
              <div class="title">{{ bestAndWorstExamData.worstExam.examName }}</div>
              <div class="content">
                <div class="item">
                  <div>
                    <div class="text" style="color:#5192F9">
                      <span>班级平均分</span>
                      <span>{{ parseFloat(bestAndWorstExamData.worstExam.classAverageScore).toFixed(2) }}分</span>
                    </div>
                    <el-progress v-if="parseFloat(bestAndWorstExamData.worstExam.totalScore) > 0" :format="format" :stroke-width="10" :show-text="false" color="#5192F9" :percentage="parseFloat(bestAndWorstExamData.worstExam.classAverageScore / bestAndWorstExamData.worstExam.totalScore * 100)"></el-progress>
                  </div>
                  <div>
                    <div class="text" style="color:#48BFFE">
                      <span>击败本班级同学</span>
                      <span>{{ parseFloat(bestAndWorstExamData.worstExam.classBitRatio * 100).toFixed(2) }}%</span>
                    </div>
                    <el-progress :format="format" :stroke-width="10" :show-text="false" color="#48BFFE" :percentage="bestAndWorstExamData.worstExam.classBitRatio * 100"></el-progress>
                  </div>
                </div>
                <div class="item">
                  <div id="worstPieChart"></div>
                </div>
                <div class="item">
                  <div>
                    <div class="text" style="color:rgba(255, 213, 132, 1)">
                      <span>年级平均分</span>
                      <span>{{ parseFloat(bestAndWorstExamData.worstExam.gradeAverageScore).toFixed(2) }}分</span>
                    </div>
                    <el-progress v-if="parseFloat(bestAndWorstExamData.worstExam.totalScore) > 0" :format="format" :stroke-width="10" :show-text="false" color="rgba(255, 213, 132, 1)" :percentage="parseFloat(bestAndWorstExamData.worstExam.gradeAverageScore / bestAndWorstExamData.worstExam.totalScore * 100)"></el-progress>
                  </div>
                  <div>
                    <div class="text" style="color:rgba(254, 174, 104, 1)">
                      <span>击败本年级同学</span>
                      <span>{{ parseFloat(bestAndWorstExamData.worstExam.gradeBitRatio * 100).toFixed(2) }}%</span>
                    </div>
                    <el-progress :format="format" :stroke-width="10" :show-text="false" color="rgba(254, 174, 104, 1)" :percentage="bestAndWorstExamData.worstExam.gradeBitRatio * 100"></el-progress>
                  </div>
                </div>
              </div>
            </div>
            <div v-else style="text-align: center;height: 150px;padding-top: 70px;color:#999;background-color:#fff">
              <img src="~images/nodata.png" alt width="100" />
              <p style="margin-bottom: 20px">暂无数据</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section section2">
      <el-select style="position:absolute;top:18px;right:70px;width:100px;" size="small" v-model="examOverviewSubjectCode" @change="examOverview()">
        <el-option v-for="(s, i) in subjectList" :key="i" :label="s.dicName" :value="s.dicCode"></el-option>
      </el-select>
      <div class="title">考试概述</div>
      <el-table row-class-name="section2_row_class" header-cell-class-name="section2_table_header_th" @cell-mouse-enter="onCellMouseEnter" @cell-mouse-leave="onCellMouseLeave" :data="examOverviewData" v-loading="examOverviewLoading">
        <el-table-column label="考试名称" align="left">
          <template slot-scope="scope">
            <span>{{ scope.row.examName }}</span>
            <span v-if="scope.row.isMore == 2">
              <img width="16" height="16" v-if="scope.row.isHover" src="~images/region_exam_mark_w.png" alt />
              <img width="16" height="16" v-else src="~images/region_exam_mark.png" alt />
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="courseName" label="学科" align="center"></el-table-column>
        <el-table-column label="类型" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.examType }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="分数" align="center"></el-table-column>
        <el-table-column label="班级均分" align="center">
          <template slot-scope="scope">{{ parseFloat(scope.row.classAverageScore).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column label="年级均分" align="center">
          <template slot-scope="scope">{{ parseFloat(scope.row.gradeAverageScore).toFixed(2) }}</template>
        </el-table-column>
        <el-table-column prop="classRanking" label="班级排名" align="center"></el-table-column>
        <el-table-column prop="gradeRanking" label="年级排名" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDetailReport(scope.row)">查看详细报告</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="section section3">
      <div class="title">学科竞争力</div>
      <div class="exam-ranking-subject">
        <el-select style="width:100px;" size="small" v-model="examRankingSubjectCode" @change="examRanking()">
          <el-option v-for="(s, i) in subjectList" :key="i" :label="s.dicName" :value="s.dicCode"></el-option>
        </el-select>
      </div>
      <div class="switch">
        <div @click="examRankingType = 1" :class="{ active: examRankingType == 1 }" class="switch-item">对比班级</div>
        <div @click="examRankingType = 2" :class="{ active: examRankingType == 2 }" class="switch-item">对比年级</div>
      </div>
      <div v-loading="examRankingLoading" v-show="examRankingData.length > 0" id="line-chart"></div>
      <div v-loading="examRankingLoading" v-show="examRankingData.length == 0" class="not-data">
        <img src="~images/nodata.png" alt width="100" />
        <p style="margin-bottom: 20px">暂无数据</p>
      </div>
    </div>
    <div class="section section4">
      <div class="title">薄弱知识点情况</div>
      <div class="legend">
        <template v-if="currentPointOverviewSubject.examBases">
          <span style="font-size:14px">知识点考试：</span>
          <el-select style="width:200px;" size="small" v-model="selectExamId" clearable @change="pointOverviewDetail">
            <el-option v-for="(s, i) in currentPointOverviewSubject.examBases" :key="i" :title="s.examName" :label="s.examName" :value="s.id"></el-option>
          </el-select>
          <i class="el-icon-question" style="margin-right:10px;font-size: 18px;" title="根据所选知识点筛选考试"></i>
        </template>

        <div class="item">
          <span class="circle" :style="{ backgroundColor: colorList[currentPointSubjectIndex] }"></span>
          <span>薄弱知识点</span>
        </div>
        <div class="item">
          <span class="circle" :style="{ backgroundColor: colorListOpacity[currentPointSubjectIndex] }"></span>
          <span>已掌握知识点</span>
        </div>
      </div>
      <div ref="scroll_container" style="overflow:hidden">
        <div ref="container" class="container scroll_container">
          <div @click="handleClick(subject, i)" v-for="(subject, i) in pointOverviewData" :key="i" class="item">
            <div :id="'pie-chart' + i" class="pie-chart"></div>
            <div class="subject-name" :style="{ color: colorList[i] }">{{ subject.subjectName }}</div>
            <div v-if="i == currentPointSubjectIndex" class="tringle" :style="{ backgroundColor: colorList[currentPointSubjectIndex] }"></div>
          </div>
        </div>
      </div>

      <div class="container">
        <el-table row-class-name="section4_row_class" :header-cell-style="{ 'background-color': colorList[currentPointSubjectIndex], 'color': '#fff' }" :data="currentPointOverviewData" max-height="400">
          <el-table-column prop="objectName" width="240" label="知识点" align="left"></el-table-column>
          <el-table-column prop="examNum" label="考试次数" align="center"></el-table-column>
          <el-table-column prop="examWeakNum" label="薄弱次数" align="center"></el-table-column>
          <el-table-column min-width="100px" label="平均掌握度" align="center">
            <template slot-scope="scope">
              <el-rate v-model="scope.row.starScore" disabled :max="5" text-color="#ff9900" score-template="{value}"></el-rate>
            </template>
          </el-table-column>
          <el-table-column label="个人平均得分率" align="center">
            <template slot-scope="scope">
              <span>{{ parseFloat(scope.row.studentRate * 100).toFixed(2) }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="班级平均得分率" align="center">
            <template slot-scope="scope">
              <span>{{ parseFloat(scope.row.classRate * 100).toFixed(2) }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="年级平均得分率" align="center">
            <template slot-scope="scope">
              <span>{{ parseFloat(scope.row.gradeRate * 100).toFixed(2) }}%</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button style="color:#666" type="text" size="small" @click="seeQuestion(scope.row)">查看题目</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!--导出报告提示框-->
    <yue-dialog title="提示" :visible.sync="exportDialogVisible" size="tiny">
      <el-row>
        <el-col :span="12" style="text-align:right;color:#333;fontSize:15px;line-height:30px;">
          <span v-if="exportLoading">报表生成中</span>
          <span v-if="!exportLoading"></span>
        </el-col>
        <el-col :span="12">
          <div class="spinner" v-if="exportLoading">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </el-col>
      </el-row>
      <span @click="exportDialogVisible = false" v-if="!exportLoading" style="text-align: center;
        display: inline-block;
        width: 100%;" download="proposed_file_name">
        报表生成成功，点击
        <a :href="url" style="text-decoration: underline;color: #2877FF;" download>下载</a>
      </span>
    </yue-dialog>

    <yue-dialog :title="pointQuestionTitle" center :visible.sync="pointQuestionDialog" width="60%">
      <div class="point-question-container" v-loading="questionLoading">
        <template v-if="pointQuestionData.length > 0">
          <div class="point-question-item" v-for="(ques, i) in pointQuestionData" :key="i">
            <div class="header">
              <div class="seq">{{ i + 1 }}</div>
              <div class="source">
                <span>题目来源：</span>
                <span style="color:#999;">{{ ques.examName }}</span>
              </div>
            </div>
            <div class="body">
              <div class="content">
                <div v-if="ques.questionInfo.content" class="ques-body" v-html="ques.questionInfo.content"></div>
                <div v-else style="color: #999">该题内容为空</div>
                <div class="option" v-for="(opt, j) in (ques.questionInfo.options || [])" :key="j">
                  <span>{{ optionList[j] }}</span>
                  <div style="display:inline-block" v-html="opt.content"></div>
                </div>
              </div>
              <div class="detail">
                <div class="detail-item">
                  <span class="label">【班级作答情况】</span>
                  <span>班级共{{ ques.studentNum }}人回答该题，平均得分率为{{ parseFloat(ques.classRate * 100).toFixed(2) }}%</span>
                </div>
                <div class="detail-item">
                  <span class="label">【知识点】</span>
                  <span class="point-item" v-for="(p, k) in ques.items" :key="k">{{ p.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <div v-else class="not-data">
          <img src="~images/nodata.png" alt width="100" />
          <p style="margin-bottom: 20px">暂无数据</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pointQuestionDialog = false">确 定</el-button>
      </span>
    </yue-dialog>
  </div>
</template>
<script>
import echarts from "echarts/lib/echarts";
import NumberAnimated from "@/components/common/NumberAnimated";
import { reportApi } from '@/v2/utils/api'

import { getStudentLocus } from "@/api/teachingArchives.js";
import { mapGetters } from "vuex";
import util from "@/utils/util";
import { domain } from "@/config";
import { configApi } from "@/api/api";

export default {
  data () {
    return {
      ifRadarChartShow: true,
      examOverviewLoading: false,
      questionLoading: false,
      currentPointSubjectIndex: 0,
      colorList: [
        "rgba(81,146,249, 1)",
        "rgba(255, 208, 116, 1)",
        "rgba(254, 174, 104, 1)",
        "rgba(255, 119, 119, 1)",
        "rgba(72, 191, 254, 1)",
        "rgba(196, 145, 255, 1)",
        "rgba(81,146,249, 1)",
        "rgba(255, 208, 116, 1)",
        "rgba(254, 174, 104, 1)",
        "rgba(255, 119, 119, 1)",
        "rgba(72, 191, 254, 1)",
        "rgba(196, 145, 255, 1)",
        "rgba(81,146,249, 1)",
        "rgba(255, 208, 116, 1)",
        "rgba(254, 174, 104, 1)",
        "rgba(255, 119, 119, 1)",
        "rgba(72, 191, 254, 1)",
        "rgba(196, 145, 255, 1)"
      ],
      colorListOpacity: [
        "rgba(81,146,249, 0.16)",
        "rgba(255, 208, 116, 0.16)",
        "rgba(254, 174, 104, 0.16)",
        "rgba(255, 119, 119, 0.16)",
        "rgba(72, 191, 254, 0.16)",
        "rgba(196, 145, 255, 0.16)",
        "rgba(81,146,249, 0.16)",
        "rgba(255, 208, 116, 0.16)",
        "rgba(254, 174, 104, 0.16)",
        "rgba(255, 119, 119, 0.16)",
        "rgba(72, 191, 254, 0.16)",
        "rgba(196, 145, 255, 0.16)",
        "rgba(81,146,249, 0.16)",
        "rgba(255, 208, 116, 0.16)",
        "rgba(254, 174, 104, 0.16)",
        "rgba(255, 119, 119, 0.16)",
        "rgba(72, 191, 254, 0.16)",
        "rgba(196, 145, 255, 0.16)"
      ],
      optionList: ["A.", "B.", "C.", "D.", "E.", "F.", "G.", "H.", "I.", "J."],
      pointQuestionData: [],
      examRankingType: 1,
      examRankingData: [],
      examRankingLoading: false,
      pointQuestionTitle: "",
      pointQuestionDialog: false,
      currentPointOverviewSubject: {},
      currentPointOverviewData: [],
      pointOverviewData: [],
      examOverviewSubjectCode: "",
      examRankingSubjectCode: "",
      examOverviewData: [],
      // schoolId: "1138998764007342080",
      studentId: "",
      studentOverviewData: {
        examNum: 0,
        schoolExamNum: 0,
        regionExamNum: 0,
        wonderNum: 0,
        goodNum: 0,
        passNum: 0,
        tiredNum: 0
      },
      bestAndWorstExamData: {
        best: {
          classAverageScore: 0,
          classBitRatio: 0,
          classRanking: 0,
          examName: "",
          gradeAverageScore: 0,
          gradeBitRatio: 0,
          gradeRanking: 0,
          schoolBitRatio: 0,
          schoolRanking: 0,
          score: 0,
          totScore: 100
        },
        bad: {
          classAverageScore: 0,
          classBitRatio: 0,
          classRanking: 0,
          examName: "",
          gradeAverageScore: 0,
          gradeBitRatio: 0,
          gradeRanking: 0,
          schoolBitRatio: 0,
          schoolRanking: 0,
          score: 0,
          totScore: 100
        }
      },
      startYearData: {},
      studentGradeList: [],
      domain: domain,
      exportLoading: false,
      exportDialogVisible: false,
      url: "",
      examNum: 0,
      examNumInRegion: 0,
      examNumInSchool: 0,
      studentDetail: {},
      bestExam: {},
      comprehensive: [],
      comprehensiveLoading: false,
      rankingLoading: false,
      knowledgeLoading: false,
      weakLoading: false,
      rankingData: [],
      knowledgeData: [],
      weakData: [],
      rankingType: 1,
      rankingSubjectCode: "",
      knowledgeType: 1,
      knowledgeSubjectCode: "",
      weakSubjectCode: "",
      weakType: 1,
      subjectList: [],
      typeList: [
        "",
        "学前测试",
        "周练",
        "单元练习",
        "月练",
        "期中考试",
        "期末考试",
        "模拟考试",
        "其他"
      ],
      selectExamId: '',
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo"
    })
  },
  watch: {
    startYearData () {
      this.getAuthSubjectList();
      this.getStudentOverview();
      this.getStudentComprehensive();
      this.bestAndWorstExam();
      this.pointOverview();
    },
    currentPointOverviewSubject () {
      this.selectExamId = ''
      this.pointOverviewDetail();
    },
    examRankingType () {
      if (this.examRankingData.length > 0) {
        this.drawLineChart();
      }
    },
  },
  methods: {
    onCellMouseEnter (row, column, cell, event) {
      row.isHover = true;
    },
    onCellMouseLeave (row, column, cell, event) {
      row.isHover = false;
    },
    handleDetailReport (row) {
      let url = "/exam/single/report/class/transcript/" + row.examId + "/" + this.studentDetail.classId + "/" + this.studentId + "/transcriptBasic?name=" + this.studentDetail.studName + "&reportType=0&className=" + this.studentDetail.className;
      this.$router.push(url);
    },
    handleClick (subject, i) {
      this.currentPointSubjectIndex = i;
      this.currentPointOverviewSubject = subject;
      let p_w = this.$refs.scroll_container.offsetWidth;
      let c_w = this.$refs.container.scrollWidth;
      let c_marginLeft = this.$refs.container.style.marginLeft;
      let marginLeft = -(i * 260 - p_w / 2 + 130);
      if (marginLeft > 0) {
        marginLeft = 0;
      }
      if (marginLeft < p_w - c_w) {
        marginLeft = p_w - c_w;
      }
      this.$refs.container.style.marginLeft = marginLeft + "px";
    },
    drawBestWorstPieChart (dom, data) {
      let options = {
        title: {
          text: data.score,
          x: "center",
          y: "center",
          textStyle: {
            color: "rgba(51, 51, 51, 1)",
            fontSize: 30,
            fontWeight: "bold"
          }
        },
        grid: {
          top: "0",
          left: "0",
          right: "0",
          bottom: "0",
          containLabel: true
        },
        series: [
          {
            startAngle: 180,
            type: "pie",
            hoverAnimation: false,
            radius: ["55%", "70%"],
            label: {
              normal: {
                show: false,
                position: "center",
                textStyle: {
                  color: "#333"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },
            data: [
              {
                value: data.score,
                itemStyle: {
                  color:
                    dom == "bestPieChart" ? "#5192F9" : "rgba(255, 119, 119, 1)"
                }
              },
              {
                value: data.totalScore - data.score,
                itemStyle: {
                  color:
                    dom == "bestPieChart"
                      ? "rgba(81,146,249,0.16)"
                      : "rgba(255, 119, 119, 0.16)"
                }
              }
            ]
          }
        ]
      };
      let myChart = echarts.init(document.getElementById(dom));
      myChart.setOption(options);
    },
    drawLineChart () {
      let that = this;

      let options = {
        tooltip: {
          trigger: "axis",
          formatter: function (params, ticket, callback) {
            var dIndex = params[0].dataIndex;
            var data = that.examRankingData[dIndex];
            let string = "";
            if (that.examRankingType == 1) {
              return (
                data.examName +
                "<br>" +
                "超过了" +
                parseFloat(data.classBitRatio * 100).toFixed(2) +
                "%的班级同学<br>" +
                (data.preClassBitRatioDiff >= 0 ? '上升了' : '下降了') +
                parseFloat(Math.abs(data.preClassBitRatioDiff * 100)).toFixed(2) +
                "%"
              );
            } else {
              return (
                data.examName +
                "<br>" +
                "超过了" +
                parseFloat(data.gradeBitRatio * 100).toFixed(2) +
                "%的年级同学<br>" +
                (data.preGradeBitRatioDiff >= 0 ? '上升了' : '下降了') +
                parseFloat(Math.abs(data.preGradeBitRatioDiff * 100)).toFixed(2) +
                "%"
              );
            }
          }
        },
        grid: {
          top: "8%",
          left: "1%",
          right: "4%",
          bottom: "8%",
          containLabel: true
        },
        xAxis: [
          {
            name: "日期",
            type: "category",
            nameTextStyle: {
              color: "rgba(102, 102, 102, 1)",
              fontSize: 12
            },
            boundaryGap: true,
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: "rgba(229, 229, 229, 1)"
              }
            },
            axisLabel: {
              //坐标轴刻度标签的相关设置
              textStyle: {
                color: "rgba(153, 153, 153, 1)",
                margin: 15
              }
            },
            axisTick: { show: false },
            data: this.examRankingData.map(exam => {
              return util.formatDate(exam.examTime);
            })
          }
        ],
        yAxis: [
          {
            name: "百分比",
            nameTextStyle: {
              color: "rgba(102, 102, 102, 1)",
              fontSize: 12
            },
            type: "value",
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(229, 229, 229, 1)",
                type: "dashed"
              }
            },
            axisLine: { show: false },
            axisLabel: {
              margin: 20,
              textStyle: {
                color: "rgba(153, 153, 153, 1)"
              }
            },
            axisTick: { show: false }
          }
        ],
        series: [
          {
            type: "line",
            smooth: true, //是否平滑曲线显示
            symbolSize: 10,
            itemStyle: {
              color: "#5192F9"
            },
            symbol: "circle",
            lineStyle: {
              normal: {
                color: "#5192F9" // 线条颜色
              }
            },
            areaStyle: {
              //区域填充样式
              normal: {
                //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    { offset: 0, color: "rgba(81,146,249, 0.7)" },
                    { offset: 0.9, color: "rgba(81,146,249, 0)" }
                  ],
                  false
                )
              }
            },
            data: this.examRankingData.map(exam => {
              return this.examRankingType == 1
                ? parseFloat(exam.classBitRatio * 100).toFixed(2)
                : parseFloat(exam.gradeBitRatio * 100).toFixed(2);
            })
          }
        ]
      };
      let myChart = echarts.init(document.getElementById("line-chart"));
      myChart.setOption(options);
    },
    async seeQuestion (row) {
      this.pointQuestionData = [];
      this.pointQuestionDialog = true;
      this.questionLoading = true;
      let params = {
        data: {
          studentId: this.studentId,
          academicYear: this.startYearData.startYear,
          schoolId: this.studentDetail.schoolId,
          objectId: row.objectId,
        },
        examIds: row.examIds
      }
      let res = await reportApi.pointQuestion(params);
      this.questionLoading = false;
      if (res.success) {
        this.pointQuestionData = res.body;
        this.pointQuestionTitle = row.objectName;
      } else {
        this.pointQuestionData = [];
        this.$message.error(res.message);
      }
    },
    drawPointDetailPie (subject, i) {
      let options = {
        title: {
          text: subject.weakPointNum,
          subtext: `共${subject.items.length || 0}个知识点`,
          left: "center",
          top: "35%",
          textStyle: {
            color: this.colorList[i],
            fontSize: 36,
            fontWeight: "bold"
          },
          subtextStyle: {
            color: "rgba(51, 51, 51, 1)",
            fontSize: 14,
            fontWeight: "normal"
          }
        },
        series: [
          {
            startAngle: 180,
            type: "pie",
            hoverAnimation: false,
            radius: ["50%", "70%"],
            label: {
              normal: {
                show: false,
                position: "center",
                textStyle: {
                  color: "#333"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },

            data: [
              {
                value: subject.weakPointNum,
                itemStyle: { color: this.colorList[i] }
              },
              {
                value: (subject.items.length || 0) - subject.weakPointNum,
                itemStyle: { color: this.colorListOpacity[i] }
              }
            ]
          }
        ]
      };
      let myChart = echarts.init(document.getElementById("pie-chart" + i));
      myChart.setOption(options);
    },
    async pointOverviewDetail () {
      let params = {
        data: {
          studentId: this.studentId,
          academicYear: this.startYearData.startYear,
        },
        subject: this.currentPointOverviewSubject
      }
      if (!util.isEmpty(this.selectExamId)) {
        params.data.examId = this.selectExamId
      }
      let res = await reportApi.pointOverviewDetail(params);
      if (res.success) {
        if (res.body && res.body.length > 0) {
          this.currentPointOverviewData = (res.body || []).map(r => {
            r.starScore = r.studentRate * 5;
            return r;
          });
        } else {
          this.currentPointOverviewData = [];
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async pointOverview () {
      let res = await reportApi.pointOverview({
        studentId: this.studentId,
        academicYear: this.startYearData.startYear
      });
      if (res.success) {
        this.pointOverviewData = res.body;
        setTimeout(() => {
          this.pointOverviewData.map((p, i) => {
            this.drawPointDetailPie(p, i);
          });
        }, 200);
        if (this.pointOverviewData.length > 0) {
          this.currentPointOverviewSubject = this.pointOverviewData[0];
        } else {
          this.currentPointOverviewSubject = {};
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async examRanking () {
      this.examRankingLoading = true;
      this.examRankingData = [];
      let res = await reportApi.examOverview({
        studentId: this.studentId,
        academicYear: this.startYearData.startYear,
        subjectCode: this.examRankingSubjectCode
      });
      this.examRankingLoading = false;
      this.examOverviewLoading = false;
      if (res.success) {
        this.examRankingData = res.body;
        if (this.examRankingData.length > 0) {
          setTimeout(() => {
            this.drawLineChart();
          }, 200);
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async examOverview () {
      this.examOverviewLoading = true;
      this.examOverviewData = [];
      let res = await reportApi.examOverview({
        studentId: this.studentId,
        academicYear: this.startYearData.startYear,
        subjectCode: this.examOverviewSubjectCode
      });
      this.examOverviewLoading = false;
      if (res.success) {
        this.examOverviewData = res.body.map(r => {
          r.isHover = false;
          return r;
        });
      } else {
        this.$message.error(res.message);
      }
    },
    async bestAndWorstExam () {
      let res = await reportApi.bestAndWorstExam({
        studentId: this.studentId,
        academicYear: this.startYearData.startYear
      });
      if (res.success) {
        if (Object.keys(res.body.bestExam || []).length == 0 && Object.keys(res.body.worstExam || []).length == 0) {
          this.ifRadarChartShow = false;
          return;
        }
        this.bestAndWorstExamData = res.body;
        this.ifRadarChartShow = true;
        this.$nextTick(() => {
          this.drawBestWorstPieChart(
            "bestPieChart",
            this.bestAndWorstExamData.bestExam || {}
          );
          this.drawBestWorstPieChart(
            "worstPieChart",
            this.bestAndWorstExamData.worstExam || {}
          );
        });
      } else {
        this.$message.error(res.message);
      }
    },
    async getStudentOverview () {
      let res = await reportApi.getStudentOverview({
        studentId: this.studentId,
        academicYear: this.startYearData.startYear
      });
      if (res.success) {
        this.studentOverviewData = res.body;
      } else {
        this.$message.error(res.message);
      }
    },
    format () {
      return "";
    },
    exportData () {
      this.exportLoading = true;
      this.exportDialogVisible = true;
      this.url = `${domain}/marking-report/region/student/export/exportStuden?studentId=${this.studentDetail.id}&token=${YJ_SCHOOL_STORAGE.getItem('token')}`;
      this.exportLoading = false;
    },
    async getStudentExamNum () {
      let res = await getStudentExamNum({
        studId: this.studentId
      });
      if (res.code == 200) {
        this.examNum = res.result.examNum;
        this.examNumInRegion = res.result.examNumInRegion;
        this.examNumInSchool = res.result.examNumInSchool;
      } else {
        this.$message.error(res.message);
      }
    },
    async getAuthSubjectList () {
      let res = await configApi.getGradeSubjects({
        schoolId: this.userInfo.schoolId,
        gradeId: this.startYearData.gradeId
      });
      let subjectList = []
      if (res.body) {
        for (let index = 0; index < res.body.length; index++) {
          const element = res.body[index];
          subjectList.push({
            dicCode: element.id + '',
            dicDesc: element.name,
            dicName: element.shortName,
            id: element.id
          })
        }
        let overviewSubjectCode = ''
        let rankingSubjectCode = ''
        if (subjectList.length > 0) {
          overviewSubjectCode = subjectList[0].dicCode;
          rankingSubjectCode = subjectList[0].dicCode;
        }
        this.examOverviewSubjectCode = overviewSubjectCode;
        this.examRankingSubjectCode = rankingSubjectCode;
        this.examOverview();
        this.examRanking();
      }
      this.subjectList = subjectList
    },
    async getStudentInfo () {
      let res = await getStudentLocus(this.studentId);
      if (res.body && res.body.length > 0) {
        this.studentDetail = res.body[0]
        const gradeList = this.studentDetail.studentGradeClassVos;
        if (gradeList && gradeList.length > 0) {
          this.studentGradeList = gradeList
          this.startYearData = this.studentGradeList[
            this.studentGradeList.length - 1
          ];
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async getStudentBestExam () {
      let res = await getStudentBestExam({
        studentId: this.studentId
      });
      if (res.code == 200) {
        if (res.result.length > 0) {
          this.bestExam = res.result[0];
        } else {
          this.bestExam = {};
        }
      } else {
        this.$message.error(res.message);
      }
    },
    async getStudentComprehensive () {
      let res = await reportApi.getStudentComprehensive({
        studentId: this.studentId,
        schoolId: this.userInfo.schoolId,
        academicYear: this.startYearData.startYear
      });
      if (res.success) {
        this.comprehensive = res.body;
        if (this.comprehensive.length > 0) {
          this.$nextTick(() => {
            this.drawComprehensive();
          });
        }
      } else {
        this.$message.error(res.message);
      }
    },

    drawComprehensive () {
      let data = this.comprehensive;
      let myChart = echarts.init(document.getElementById("radar"));
      let options = {
        tooltip: {
          trigger: "item",
          borderColor: "#d9dee9",
          borderWidth: 1,
          padding: [8, 10],
          formatter: function (a) {
            let res = "";
            for (let item of data) {
              res += `<p>${item.name} : ${parseFloat(item.value * 100).toFixed(2)}%</p>`;
            }
            return res;
          }
        },
        grid: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        radar: {
          name: {
            textStyle: {
              color: "#94a5bc",
              fontSize: 12
            }
          },
          splitNumber: 3,
          axisLine: {
            // (圆内的几条直线)坐标轴轴线相关设置
            lineStyle: {
              color: "#eff3f9" // 坐标轴线线的颜色。
            }
          },
          splitLine: {
            // (这里是指所有圆环)坐标轴在 grid 区域中的分隔线。
            lineStyle: {
              color: "#eff3f9" // 分隔线颜色
            }
          },
          splitArea: {
            // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: false
          },
          indicator: data.map(d => {
            return { name: d.name, max: 100 };
          })
        },
        series: [
          {
            type: "radar",
            tooltip: {
              trigger: "item"
            },
            itemStyle: { color: "#5192F9" },
            data: [
              {
                value: data.map(d => parseFloat((d.value * 100).toFixed(2)))
              }
            ]
          }
        ]
      };
      myChart.setOption(options);
    }
  },
  mounted () {
    this.studentId = this.$route.query.studentId;
    this.getStudentInfo();
  },
  components: {
    NumberAnimated
  }
};
</script>

<style lang="scss" scoped>
.header {
  height: 46px;
  line-height: 46px;

  .back {
    display: inline-block;
    cursor: pointer;

    img {
      margin-top: 16px;
      display: inline-block;
    }

    span {
      display: inline-block;
      color: #999999;
      vertical-align: top;
    }

    &:hover span {
      color: $color-theme;
    }
  }

  .export-btn {
    float: right;
    margin-top: 7px;
  }
}

.section {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 20px 30px;

  > .title {
    font-size: 20px;
    font-weight: bold;
    line-height: 29px;
    color: rgba(51, 51, 51, 1);
    margin-bottom: 30px;
  }

  .switch {
    text-align: center;
  }
}

.section1 {
  background: transparent !important;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
}

.section1 .container {
  // margin: 0 -5px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: stretch;

  > .left {
    flex: 1;
    background-color: #fff;
    border-radius: 4px;
    margin-top: 10px;
    margin-right: 10px;
  }

  > .right {
    flex: 2;

    .label {
      position: absolute;
      top: 10px;
      left: 20px;
      width: 100px;
      height: 32px;
      opacity: 1;
      line-height: 32px;
      text-align: center;
      color: #fff;
      border-radius: 18px 0px 18px 0px;
    }

    .title {
      margin: 0 auto;
      font-size: 16px;
      font-weight: 500;
      line-height: 25px;
      text-align: center;
      color: rgba(51, 51, 51, 1);
    }
  }

  .total-item {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 0 5px;
    padding: 25px 0 25px 10px;
    height: 50px;
    border-radius: 4px;
    background-color: #fff;

    .left {
      height: 50px;
      width: 50px;
      border-radius: 25px;
      background-color: rgba(81, 146, 249, 0.12);
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 15px;

      img {
        width: 30px;
        height: 30px;
        vertical-align: middle;
      }
    }

    .right {
      .item-title {
        font-size: 30px;
        font-weight: bold;
        line-height: 40px;
        color: rgba(51, 51, 51, 1);
        opacity: 1;
      }

      .desc {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        color: rgba(153, 153, 153, 1);
        opacity: 1;
      }
    }
  }

  .right .top,
  .right .bottom {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    padding: 10px 20px;
    margin-top: 10px;
  }

  .right .top .label {
    background: #5192f9;
    box-shadow: 0px 4px 8px rgba(1, 63, 161, 0.2);
  }

  .right .bottom .label {
    background: rgba(255, 119, 119, 1);
    box-shadow: 0px 3px 6px rgba(141, 5, 5, 0.16);
  }

  .right .top .content,
  .right .bottom .content {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;

    .item > div {
      margin-top: 20px;

      .text {
        font-size: 14px;
        margin-bottom: 10px;
      }
    }
  }

  #worstPieChart,
  #bestPieChart {
    height: 150px;
    width: 150px;
  }

  #radar {
    height: 400px;
  }
}

.section2 {
  position: relative;
}

.section3 {
  position: relative;

  .exam-ranking-subject {
    position: absolute;
    top: 18px;
    right: 70px;
  }

  .switch {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 28px;

    .switch-item {
      width: 120px;
      height: 34px;
      background: rgba(38, 203, 155, 0.1);
      border-radius: 17px;
      color: $color-theme;
      margin: 0 30px;
      line-height: 34px;
      font-size: 14px;
      cursor: pointer;
    }

    .active {
      background-color: $color-theme;
      color: #fff;
      box-shadow: 0px 3px 10px rgba(31, 185, 141, 0.4);
    }
  }

  #line-chart {
    height: 350px;
  }
}

.section4 {
  position: relative;

  .legend {
    position: absolute;
    top: 25px;
    right: 0;

    .item {
      display: inline-block;
      margin-right: 30px;
      color: #666666;
      font-size: 14px;
    }

    .circle {
      height: 16px;
      width: 16px;
      display: inline-block;
      border-radius: 50%;
      vertical-align: middle;
    }
  }

  .scroll_container {
    transition: all 0.3s ease-in-out;
  }

  .container {
    white-space: nowrap;

    .item {
      overflow: hidden;
      position: relative;
      cursor: pointer;
      height: 260px;
      width: 260px;
      display: inline-block;
      vertical-align: middle;

      .pie-chart {
        height: 220px;
        width: 100%;
      }

      .subject-name {
        text-align: center;
        font-size: 20px;
      }

      .tringle {
        position: absolute;
        bottom: -20px;
        left: 50%;
        height: 28px;
        width: 28px;
        transform: translateX(-14px) rotate(45deg);
      }
    }
  }
}

.info {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 20px;
  color: #fff;
  background: url("/static/images/stud_info_bg.png") center no-repeat;
  background-size: cover;
  box-shadow: 0px 6px 14px rgba(146, 146, 146, 0.16);
  border-radius: 4px;

  .grade-select-list {
    position: absolute;
    top: 10px;
    right: 10px;
    width: 100px;
  }

  .info-top {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .avatar {
      height: 56px;
      width: 56px;
      border-radius: 35px;
      background-color: rgba(255, 255, 255, 0.5);
      border: 7px solid rgba(255, 255, 255, 0.4);
      text-align: center;
      line-height: 56px;
      font-size: 24px;
      font-weight: bold;
      color: #5192f9;
      opacity: 1;
    }

    .name {
      margin-left: 20px;
      font-size: 30px;
      font-weight: 500;
      line-height: 70px;
      color: rgba(255, 255, 255, 1);
      opacity: 1;
    }
  }

  .info-bottom {
    width: 100%;
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 29px;
    color: rgba(255, 255, 255, 1);
    opacity: 1;
  }

  div {
    > span {
      margin-right: 10px;
      font-size: 20px;
    }

    .name {
      font-weight: bold;
      margin-right: 20px;
      font-size: 18px;
    }
  }
}

.progress-container {
  padding: 5px 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .text {
    color: #666;
    font-size: 14px;
    margin-left: 20px;
  }

  .el-row:not(:last-of-type) {
    border-bottom: 1px dotted #e5e5e5;
  }
}

.el-progress {
  flex: 1;
}

.point-question-container {
  .point-question-item {
    margin-top: 15px;
    border: 1px solid #e5e5e5;

    .header {
      height: 30px;
      line-height: 30px;
      padding: 0 20px;
      color: #333;
      border-bottom: 1px solid #e5e5e5;
      background-color: #f2f2f2;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }

    .body {
      padding: 20px;

      .content {
        line-height: 20px;
        border-bottom: 1px dashed #e5e5e5;
        padding-bottom: 10px;

        .ques-body {
          padding-bottom: 10px;
        }
      }

      .detail {
        .detail-item {
          margin-top: 10px;
          line-height: 20px;

          .label {
            color: #2ab98d;
          }

          .point-item {
            margin-right: 15px;
          }
        }
      }
    }
  }
}

::v-deep .section2_row_class,
::v-deep .section4_row_class {
  color: #999;
}

::v-deep .section2_row_class {
  .el-button--text {
    color: #5192f9;
  }
}

::v-deep .section2_row_class:hover {
  color: #fff;
  background: #5192f9;
  box-shadow: 0px 6px 14px rgba(51, 51, 51, 0.16);
  border-radius: 8px;

  td {
    background-color: #5192f9 !important;
  }

  .el-button--text {
    color: #fff;
  }
}

::v-deep .section2_table_header_th {
  background-color: transparent !important;
  font-weight: 400;
  color: #666;
}

.not-data {
  text-align: center;
  height: 150px;
  padding-top: 70px;
  color: #999;
  background-color: #fff;
}
</style>
